import { useIntl } from 'react-intl'
import { Tag } from 'ui'
import { AdvancedConfigProps } from '.'
import { messages } from '../../messages'

export function DistributedTag(props: AdvancedConfigProps) {
  const {
    config: { distributed },
  } = props
  const { $t } = useIntl()
  const {
    benefit: { advanced },
  } = messages

  return <Tag>{$t(advanced.distributed, { value: distributed })}</Tag>
}
